<template>
    <div class="">
        <gcmcn-filters
            ref="gcmcn-filters"
            :filter-values="[searchFilter, selectedfeedStatus, dateRange, selectedEntitiesForFilter]"
            @reset-filters="resetFilters"
        >
            <dropdown
                name="Status"
                :list="$store.getters.availableFeedStatus"
                itemName="name"
                itemValue="value"
                :itemsSelected="selectedfeedStatus"
                @on-select-item="selectedfeedStatus = $event"
            ></dropdown>
            <dropdown
                name="Entities"
                :multiple="true"
                :list="$store.getters.entities"
                itemName="display_name"
                itemValue="uid"
                :itemsSelected="selectedEntitiesForFilter"
                @on-select-item="onSelectEntity"
            ></dropdown>
            <dropdown
                name="Universes"
                :multiple="true"
                :list="filteredUniverses"
                itemName="display_name"
                itemValue="uid"
                :itemsSelected="selectedUniversesForFilter"
                @on-select-item="onSelectUniverses"
            ></dropdown>
            <dropdown
                name="Events"
                :multiple="true"
                :list="filteredEvents"
                itemName="name"
                itemValue="uid"
                :itemsSelected="selectedEventsForFilter"
                @on-select-item="onSelectEvents"
            ></dropdown>
            <date-picker-range ref="date-range" @on-range-selected="setDaterange"></date-picker-range>
            <search-filter ref="search" @new-value="searchFilter = $event"></search-filter>
        </gcmcn-filters>
        <div v-if="filteredFeeds.length > 0" class="feed-ns-loader">
            <virtual-list
                ref="feed-list"
                class="feed-virtual-list"
                :style="{height: `calc(100vh - ${this.usedHeight}px)`}"
                :data-key="'uid'"
                :data-sources="filteredFeeds"
                :data-component="itemComponent"
                :keeps="10"
                item-class="feed-item"
                :extra-props="{
                    otherPropValue: {
                        universes: universes,
                        events: events,
                        configurations: configurations,
                        displayConfigButton: false,
                        selectedFeed: selectedFeed,
                        defaultPreviewImageUrl: defaultPreviewImageUrl,
                        unMutedFeedsUid: unMutedFeedsUid,
                        feedResources: feedResources
                    }
                }"
                @select-feed="selectFeed"
                @resized="onVirtualListResize"
            ></virtual-list>
        </div>
        <div v-else class="list-empty">no feed</div>
    </div>
</template>

<script>

import {
    Dropdown,
    DatePickerRange,
    SearchFilter,
    GcmcnFilters,
} from 'gcmcn-common';
import moment from 'moment';
import VirtualList from 'vue-virtual-scroll-list';
import FeedCard from './feed-card.vue';
import {mapGetters} from 'vuex';
export default {

    components: {
        FeedCard,
        Dropdown,
        DatePickerRange,
        SearchFilter,
        VirtualList,
        GcmcnFilters,
    },
    name: 'feeds-view',

    props: {
        selectedFeed: {
            required: true,
        },
        feeds: {
            type: Array,
            required: true,
        },
        configurations: {
            type: Array,
            required: true,
        },
        universes: {
            type: Array,
            required: true,
        },
        events: {
            type: Array,
            required: true,
        },
        feedResources: {
            type: Array,
            required: true,
        },
    },

    data (){
        return {
            selectedfeedStatus: [],
            dateRange: '',
            searchFilter: '',
            itemComponent: FeedCard,
            unMutedFeedsUid: [],
            usedHeight: 0,
            resized: false,
        };
    },
    created() {
        this.$on('toggleSound', (payload) => {
            if (payload.muted === false) {
                if (!this.unMutedFeedsUid.includes(payload.feedUid)) {
                    this.unMutedFeedsUid.push(payload.feedUid);
                }
            } else {
                if (this.unMutedFeedsUid.includes(payload.feedUid)) {
                    this.unMutedFeedsUid.splice(this.unMutedFeedsUid.indexOf(payload.feedUid), 1);
                }
            }
        });
    },
    computed: {
        ...mapGetters([
            'windowWidth',
            'selectedEntitiesForFilter',
            'selectedUniversesForFilter',
            'selectedEventsForFilter'
        ]),
        filteredUniverses(){
            if(this.selectedEntitiesForFilter.length > 0){
                let universes = [...this.universes];
                let filteredUniverses = universes.filter(universe=>{
                    return  this.selectedEntitiesForFilter.includes(universe.scopes.entity_uid);

                });
                return filteredUniverses;
            }
            return this.universes;
        },
        filteredEvents(){
            let filteredEvents = [...this.events];
            if(this.selectedEntitiesForFilter.length > 0){
                filteredEvents = filteredEvents.filter(event=>{
                    return  this.selectedEntitiesForFilter.includes(event.scopes.entity_uid);
                });
            }
            if(this.selectedUniversesForFilter.length > 0){
                // returns all event based on universe‡
                filteredEvents = filteredEvents.filter(event=>{
                    return  this.selectedUniversesForFilter.includes(event.universe_uid);
                });
            }
            return filteredEvents;
        },
        filteredFeeds (){
            let feeds = this.feeds.slice();
            if(this.selectedfeedStatus.length > 0){
                feeds = feeds.filter((feed) => this.selectedfeedStatus.includes(feed.status));
            }
            if(this.selectedEntitiesForFilter.length > 0){
                feeds = feeds.filter((feed) => this.selectedEntitiesForFilter.includes(feed.scopes.entity_uid));
            }
            if(this.selectedUniversesForFilter.length > 0){
                /*
                    No direct link between feed and universe so we return all feeds based on relation between event and universe
                */
                let eventUids = this.filteredEvents.map(event => event.uid);
                feeds = feeds.filter((feed) => eventUids.includes(feed.event_uid));
            }
            if(this.selectedEventsForFilter.length > 0){
                feeds = feeds.filter((feed) => this.selectedEventsForFilter.includes(feed.event_uid));
            }
            if(this.dateRange.length > 0){
                // obbligé d'ajouter 1 jours car si le user selectionne par exemple le 30/07/2020 la valeur retournée sera 29/07/2020
                let start = moment.utc(this.dateRange[0]).set({hour: 0, minute: 0, second: 0}).add(1, 'days');
                let end = moment.utc(this.dateRange[1]).set({hour: 23, minute: 59, second: 59}).add(1, 'days');
                feeds = feeds.filter((feed) => {
                    const feedStartDate = feed.confirmed ? feed.confirmed_start_date : feed.start_date;
                    const feedEndDate = feed.confirmed ? feed.confirmed_end_date : feed.end_date;
                    return moment.utc(feedStartDate).isAfter(start) && moment.utc(feedEndDate).isBefore(end);
                });
            }
            if(this.searchFilter.length > 0){
                let searchFilter = this.searchFilter.toLowerCase();
                feeds = feeds.filter((feed) => feed.display_name.toLowerCase().includes(searchFilter) ||
                    this.events.find((ev) => ev.uid === feed.event_uid).name.toLowerCase().includes(searchFilter)
                );
            }
            return this.$store.getters.orderingFeeds(feeds);
        },
        defaultPreviewImageUrl() {
            return '../../../../static/image/no_preview.png';
        },
    },

    watch: {
        windowWidth (){
            this.computeFilterHeight();
        },
    },
    mounted (){
        this.computeFilterHeight();
    },

    methods: {
        computeFilterHeight() {
            if(this.$refs['gcmcn-filters']){
                const clientRect = this.$refs['gcmcn-filters'].$el.getBoundingClientRect();
                this.usedHeight = clientRect.top + clientRect.height + 10 + 32; // +10 par ce que l'element contient un margin, et les margin ne sont pas comptés dans la height d'un element
                // 32 -> on enleve la height du wrapper d'alerte de fundation
            }
        },
        onVirtualListResize (){
            if( !this.resized && this.$route.params.feedUid && this.$refs['feed-list']){
                let sources = this.$refs['feed-list'].dataSources;
                for(let key in sources){
                    if(sources[key].uid === this.$route.params.feedUid){
                        this.$refs['feed-list'].scrollToIndex(key);
                        this.resized = true;
                        break;
                    }
                }
            }
        },
        setDaterange (val){
            this.$set(this, 'dateRange', val);
        },
        resetFilters (){
            this.$set(this, 'selectedfeedStatus', []);
            this.$refs.search.clear();
            this.$refs['date-range'].clear();
            this.$store.commit('CLEAR_ALL_FILTERS');
        },
        selectFeed (feed){
            this.$emit('select-feed', feed);
        },
        onSelectEntity (entities){
            this.$store.commit('SET_ENTITIES_FOR_FILTER', entities);
        },
        onSelectUniverses (universes){
            this.$store.commit('SET_UNIVERSES_FOR_FILTER', universes);
        },
        onSelectEvents (events){
            this.$store.commit('SET_EVENTS_FOR_FILTER', events);
        },
    },
};
</script>

<style lang="scss">
.feed-view{
    .feed-view-heading{
        display: flex;
        justify-content: space-between;
        align-items: baseline;
    }
    .feed-item+.feed-item {
        margin-top: 15px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/page/Feeds/feed-list.vue